﻿import { createFileRoute } from "@tanstack/react-router";
import { EditarInsumoPage } from "@/paginas/pg_insumos/insumos-editar-insumo";

export const Route = createFileRoute("/_authenticated/insumos-editar-insumo")({
  head: () => ({
    meta: [
      { title: "Insumo — Milky Moo Palmares" },
      { name: "description", content: "Editar insumo" },
      { property: "og:title", content: "Insumo — Milky Moo Palmares" },
      { property: "og:description", content: "Editar insumo" },
    ],
  }),
  component: EditarInsumoPage,
});
